// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2dAT3","filesListContainer":"PosDisputesFiles_filesListContainer__3bR9J","filesButton":"PosDisputesFiles_filesButton__fU2UD"};